import SlideoutCancelamento from './SlideoutCancelamento.vue';

export default SlideoutCancelamento;
